// AI-CONTEXT: See docs/features/impact-in-beeld-fase2.md
import { computeProductImpact } from './computeProductImpact'

/**
 * @typedef {object} PublicationBranding
 * @property {string} Logo - Logo download-URL ('' als geen logo)
 * @property {string} Name - Organisatienaam
 * @property {string} PrimaryColor - Merkkleur ('' als niet gezet)
 * @property {string} SecundairyColor - Merkkleur (bewuste spelling)
 * @property {string} TertairyColor - Merkkleur (bewuste spelling)
 */

/**
 * Bouwt de bevroren snapshot die bij "Publiceren" op een ImpactPublications-doc
 * wordt geschreven. Publiceren = bevriezen: de publieke pagina toont exact dit
 * object tot er opnieuw gepubliceerd wordt.
 *
 * @param {object} input
 * @param {{kengetal: number|null, status: string, jaar: number}|null} input.result - Methodiek-uitkomst (useImpactPerEuroRatio)
 * @param {string|null} input.label - Versielabel, bv. "v1.0 · definitief · 2025"
 * @param {number|null} input.totalValue - Boekjaar-gescopete maatschappelijke waarde
 * @param {Partial<PublicationBranding>} input.branding - Tenant-branding
 * @param {{Name: string, Price: number, Slug: string, OpeningLine?: string, MicroStory?: string}} [input.product] - Product voor een product-publicatie
 * @returns {object|null} het snapshot, of null zonder presenteerbaar kengetal
 *   (caller blokkeert publiceren en toont de methodiek-reden)
 */
const buildPublicationSnapshot = ({ result, label, totalValue, branding, product } = {}) => {
    if (!result || result.kengetal === null || result.kengetal === undefined) return null

    const snapshot = {
        Kengetal: result.kengetal,
        Label: label || '',
        Status: result.status,
        Jaar: result.jaar,
        TotalValue: totalValue ?? null,
        // Lege strings i.p.v. undefined — Firestore weigert undefined-velden.
        Branding: {
            Logo: branding?.Logo || '',
            Name: branding?.Name || '',
            PrimaryColor: branding?.PrimaryColor || '',
            SecundairyColor: branding?.SecundairyColor || '',
            TertairyColor: branding?.TertairyColor || '',
        },
    }

    if (!product) return snapshot

    return {
        ...snapshot,
        ProductName: product.Name,
        ProductPrice: product.Price,
        ProductImpact: computeProductImpact(product.Price, result.kengetal),
        OpeningLine: product.OpeningLine || '',
        MicroStory: product.MicroStory || '',
    }
}

export { buildPublicationSnapshot }
